<template>
    <validation-observer ref="refForm">

        <b-form @submit.prevent="onSubmit(true)">

            <b-row>
                <b-col md="12">
                    <b-card footer-tag="footer">

                        <b-row>

                            <!-- TITLE -->
                            <b-col cols="12" md="8">
                                <b-form-group label-for="title">
                                    <template #label>
                                        <strong>TÍTULO</strong>
                                    </template>
                                    <validation-provider
                                        #default="{ errors }"
                                        rules="required"
                                        name="título"
                                    >
                                        <b-form-input
                                            id="title"
                                            v-model="formData.title"
                                            placeholder="Ingrese el título del blog ..."
                                            maxlength="255"
                                            :state="errors.length > 0 ? false : null"
                                            trim
                                        />
                                        <small class="textarea-counter-value float-right">
                                            <strong class="char-count">{{ formData.title ? formData.title.length : 0 }} / 255</strong>
                                        </small>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>

                            <!-- AUTHOR -->
                            <b-col cols="12" md="4">
                                <b-form-group label-for="doctor">
                                    <template #label>
                                        <strong>AUTOR</strong>
                                    </template>
                                    <validation-provider
                                        #default="{ errors }"
                                        rules="required"
                                        name="autor"
                                    >
                                        <v-select
                                            id="doctor"
                                            placeholder="Seleccionar un psicólogo"
                                            v-model="formData.doctor"
                                            :options="options.doctors"
                                            :state="errors.length > 0 ? false : null"
                                        />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>

                            <!-- SHORT DESCRIPTION -->
                            <b-col cols="12">
                                <b-form-group label-for="short_description">
                                    <template #label>
                                        <strong>DESCRIPCIÓN CORTA</strong>
                                    </template>
                                    <validation-provider
                                        #default="{ errors }"
                                        rules="required"
                                        name="descripción corta"
                                    >
                                        <b-form-textarea
                                            id="short_description"
                                            v-model="formData.short_description"
                                            placeholder="Texto que se verá en la tarjeta del blog en la web ..."
                                            rows="3"
                                            maxlength="300"
                                            :state="errors.length > 0 ? false : null"
                                        />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                    <small class="textarea-counter-value float-right">
                                        <strong class="char-count">{{ formData.short_description ? formData.short_description.length : 0 }} / 300</strong>
                                    </small>
                                </b-form-group>
                            </b-col>

                            <!-- TAGS -->
                            <b-col cols="12">
                                <b-form-group label-for="tags">
                                    <template #label>
                                        <strong>ETIQUETAS</strong>
                                    </template>
                                    <v-select
                                        id="tags"
                                        v-model="formData.tags"
                                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                        multiple
                                        taggable
                                        push-tags
                                        placeholder="Escriba una etiqueta y presione Enter ..."
                                        :options="options.tags"
                                    />
                                    <small class="text-muted">
                                        Puede elegir etiquetas ya usadas o crear nuevas escribiéndolas y presionando Enter.
                                    </small>
                                </b-form-group>
                            </b-col>

                            <!-- IMAGE -->
                            <b-col cols="12">
                                <b-alert variant="info" :show="true">
                                    <div class="alert-body">
                                        <ul class="mb-0">
                                            <li>La imagen se usa como portada en la lista de blogs y como imagen principal del artículo.</li>
                                            <li>
                                                Comprime y optimiza tus imágenes en
                                                <b-link class="alert-link" href="https://tinypng.com/" target="_blank">Tinify</b-link>
                                            </li>
                                            <li>
                                                Convierte tus imágenes a .webp en
                                                <b-link class="alert-link" href="https://pixelied.com/convert/jpg-converter" target="_blank">Pixelied</b-link>
                                            </li>
                                        </ul>
                                    </div>
                                </b-alert>

                                <div id="preview" v-if="formData.imageUrl">
                                    <b-img
                                        fluid
                                        :src="formData.imageUrl"
                                        thumbnail
                                        width="300"
                                        alt="portada"
                                    />
                                </div>

                                <b-form-group label-for="image">
                                    <template #label>
                                        <strong>IMAGEN DE PORTADA (FORMATO: webp)</strong>
                                    </template>
                                    <validation-provider
                                        #default="{ errors }"
                                        rules="required"
                                        name="imagen"
                                    >
                                        <b-form-file
                                            id="image"
                                            v-model="formData.image"
                                            @change="onFileChange"
                                            accept=".webp"
                                            ref="image"
                                            placeholder="Elija una imagen ..."
                                            :state="errors.length > 0 ? false : null"
                                            no-drop
                                        />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                                <b-button variant="outline-primary" class="mb-2" @click="removeImage" v-if="formData.imageUrl">Eliminar imagen</b-button>
                            </b-col>

                            <!-- CONTENT -->
                            <b-col cols="12">
                                <b-form-group label-for="content">
                                    <template #label>
                                        <strong>CONTENIDO</strong>
                                    </template>
                                    <quill-editor
                                        id="content"
                                        v-model="formData.content"
                                        :options="editorOptions"
                                    />
                                </b-form-group>
                            </b-col>

                        </b-row>

                        <template #footer>

                            <b-button-loading
                                text="GUARDAR Y PUBLICAR"
                                type="submit"
                                :processing="processing">
                            </b-button-loading>

                            <!--
                                Va en outline-primary, no en outline-secondary:
                                también guarda, y de lo contrario se vería igual
                                que CANCELAR, que descarta.
                            -->
                            <b-button
                                variant="outline-primary"
                                class="ml-1"
                                :disabled="processing"
                                @click="onSubmit(false)"
                            >
                                GUARDAR COMO BORRADOR
                            </b-button>

                            <b-button
                                variant="outline-secondary"
                                class="ml-1"
                                :to="{ name: 'blogs' }"
                            >
                                CANCELAR
                            </b-button>

                        </template>

                    </b-card>
                </b-col>
            </b-row>

        </b-form>

    </validation-observer>
</template>

<script>

    import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
    import BButtonLoading from '@core/components/b-button-loading/BButtonLoading.vue';
    import { ref, onBeforeMount, onUnmounted } from '@vue/composition-api';
    import { ValidationProvider, ValidationObserver } from 'vee-validate';
    import { useToast } from 'vue-toastification/composition';
    import { quillEditor } from 'vue-quill-editor';
    import blogStoreModule from '../blogStoreModule';
    import Ripple from 'vue-ripple-directive';
    import { required } from '@validations';
    import vSelect from 'vue-select';
    import router from '@/router';
    import store from '@/store';

    export default {
        components: {
            ValidationProvider,
            ValidationObserver,

            BButtonLoading,
            quillEditor,

            required,

            vSelect
        },
        directives: {
            Ripple
        },
        setup() {

            // USE TOAST
            const toast = useToast();

            // REFS
            const processing = ref(false);
            const refForm = ref(null);
            const options = ref({ doctors: [], tags: [] });

            const image = ref(null);

            const formData = ref({
                title: null,
                doctor: null,
                short_description: null,
                tags: [],
                imageUrl: null,
                image: null,
                content: null
            });

            const editorOptions = {
                theme: 'snow',
                placeholder: 'Escriba aquí el contenido del blog ...',
                modules: {
                    toolbar: [
                        [{ header: [2, 3, 4, false] }],
                        ['bold', 'italic', 'underline', 'strike'],
                        [{ list: 'ordered' }, { list: 'bullet' }],
                        [{ align: [] }],
                        ['blockquote', 'link', 'image', 'video'],
                        ['clean']
                    ]
                }
            };

            const BLOG_APP_STORE_MODULE_NAME = 'app-blog';

            // REGISTER MODULE
            if (!store.hasModule(BLOG_APP_STORE_MODULE_NAME)) store.registerModule(BLOG_APP_STORE_MODULE_NAME, blogStoreModule);

            // UNREGISTER ON LEAVE
            onUnmounted(() => {
                if (store.hasModule(BLOG_APP_STORE_MODULE_NAME)) store.unregisterModule(BLOG_APP_STORE_MODULE_NAME);
            });

            // CALL FUNCTION TO POPULATE OPTIONS FOR THE SELECTS
            onBeforeMount(() => {
                getSelectFilters();
            });

            const getSelectFilters = async () => {
                const response = await store.dispatch('app-blog/fetchSelectOptions');
                options.value = response.data;
            };

            const onFileChange = (e) => {
                const file = e.target.files[0];

                if (file) {
                    formData.value.image = file;
                    formData.value.imageUrl = URL.createObjectURL(file);
                } else {
                    formData.value.image = null;
                    formData.value.imageUrl = null;
                }
            };

            const removeImage = () => {
                formData.value.imageUrl = null;
                formData.value.image = null;

                image.value.reset();
            };

            const showToast = (title, icon, variant) => {
                toast({
                    component: ToastificationContent,
                    props: { title, icon, variant }
                });
            };

            const onSubmit = async (publish) => {

                const isValid = await refForm.value.validate();

                if (!isValid)
                {
                    showToast('Complete los campos requeridos.', 'AlertTriangleIcon', 'warning');
                    return;
                }

                processing.value = true;

                const {

                    title,
                    doctor,
                    short_description,
                    tags,
                    image: imageFile,
                    content

                } = formData.value;

                const payload = {
                    title,
                    doctor_id: doctor ? doctor.value : null,
                    short_description,
                    // vue-select con push-tags mezcla strings (nuevas) y objetos
                    // (las que venían del servidor). Se normaliza a texto.
                    tags: (tags || []).map(tag => (typeof tag === 'string' ? tag : tag.label)),
                    content,
                    image: imageFile,
                    publish
                };

                store.dispatch('app-blog/createBlog', { payload })
                    .then(response => {

                        showToast(response.data.message, 'CheckIcon', 'success');

                        setTimeout(() => {
                            router.push({ name: 'blogs' });
                        }, 1500);

                    })
                    .catch(err => {
                        const message = err.response && err.response.data.message ? err.response.data.message : 'Error al agregar el blog.';

                        showToast(message, 'AlertTriangleIcon', 'danger');

                        processing.value = false;
                    });

            };

            return {
                // DATA
                processing,
                formData,
                editorOptions,

                // REFS
                refForm,
                options,
                image,

                // METHODS
                onFileChange,
                removeImage,
                onSubmit
            }
        }
    }

</script>

<style lang="scss" scoped>

    #preview {
        text-align: center;
        margin-bottom: 1rem;
    }

</style>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-select.scss';
    @import '@core/scss/vue/libs/quill.scss';
</style>
